type Property = {
  packageOffer?: { charges?: { total?: { amount?: number } } };
  cheapestOrigin?: { price?: { perAdult?: { amount?: number } } };
};

// Util Getters
const getProcuredOfferPrice = (property: Property) =>
  Number(property?.cheapestOrigin?.price?.perAdult?.amount || Infinity);

const getPackageOfferPrice = (property: Property) =>
  Number(property?.packageOffer?.charges?.total?.amount || Infinity);

const getIsProcuredOfferSortValue = (property: Property) =>
  'procuredOffer' in property ? -1 : 1;

// Sort Comparison Functions
const preSearchCompareFn = (a: Property, b: Property) => {
  // Sort order:
  // 1. Procured offer then standard offers
  // 2. Procured offer price (standard offers resolve to Infinity)
  return (
    getIsProcuredOfferSortValue(a) - getIsProcuredOfferSortValue(b) ||
    getProcuredOfferPrice(a) - getProcuredOfferPrice(b)
  );
};

const postSearchCompareFnPrioritiseProcuredOffers = (
  a: Property,
  b: Property,
) => {
  // Sort order:
  // 1. Procured offer then standard offers
  // 2. Package price
  return (
    getIsProcuredOfferSortValue(a) - getIsProcuredOfferSortValue(b) ||
    getPackageOfferPrice(a) - getPackageOfferPrice(b)
  );
};

const postSearchCompareFnPriceOnly = (a: Property, b: Property) => {
  // Sort order:
  // 1. Package price
  return getPackageOfferPrice(a) - getPackageOfferPrice(b);
};

export {
  preSearchCompareFn,
  postSearchCompareFnPriceOnly,
  postSearchCompareFnPrioritiseProcuredOffers,
};
